import { PoiInfoG, PoiInfoI, PoiInfoH, Toast } from '@mtfe/sweet-components';
import { createDeepLink, common } from '@mtfe/sweet-utils';

import http from '../service';
import { useAutoLogin, clickToReport } from './index';
import { fetchOneCoupon } from './fetchData';
import { COUPON_STATUS, COUPON_REMAIN_STATUS } from '../constants';

const deepLink = createDeepLink();
const { debounceByPromise } = common;

/**
 * 渲染商家的模板
 * @param {*} poiInfo
 * @param {*} itemIndex
 * @returns
 */
export const renderPoiInfoG = (poiInfo, itemIndex) => {
    const onPoiInfoGClickCb = async (currentPoiInfo) => {
        deepLink.gotoDp(currentPoiInfo.dpUrl, currentPoiInfo.lpUrl, () => {
            const componentID = PoiInfoG.describe.getComponentID();
            clickToReport(currentPoiInfo, componentID);
        });
    };
    const info = PoiInfoG({
        poiInfo,
        itemIndex,
        showCoupon: false,
        isLazyLoadImg: false,
        onPoiInfoClick: useAutoLogin(onPoiInfoGClickCb),
    });
    return `<div class="mb16">${info}</div>`;
};

export const renderPoiInfoGWithCoupon = (poiInfo, itemIndex, recallBizId) => {
    const { totalAmount = 0 } = poiInfo;
    const onPoiInfoGClickCb = async (currentPoiInfo) => {
        deepLink.gotoDp(currentPoiInfo.dpUrl, currentPoiInfo.lpUrl, () => {
            const componentID = PoiInfoG.describe.getComponentID();
            clickToReport(currentPoiInfo, componentID);
        });
    };
    const onCouponBtnClickHandler = async (currentPoiInfo, lxID) => {
        const { clickMonitorUrl, giftInfo } = currentPoiInfo;
        // 上报点击
        const componentID = lxID;
        const url = `${clickMonitorUrl}&componentId=${componentID}`;
        try {
            await http.actGeClkM(url);
        } catch (error) {
            console.error('点击上报出错', error);
        }
        if (giftInfo.status === COUPON_STATUS.STATUS_NEW) {
            // 如果是未领取过的券，领取券
            await fetchOneCoupon(currentPoiInfo, recallBizId, false);
        } else if (giftInfo.status === COUPON_STATUS.STATUS_RECEIVED) {
            // 如果是领取过的券，跳转
            deepLink.gotoDp(currentPoiInfo.dpUrl, currentPoiInfo.lpUrl);
        }
    };
    const info = PoiInfoG({
        poiInfo,
        itemIndex,
        showCoupon: true,
        isLazyLoadImg: false,
        onPoiInfoClick: useAutoLogin(onPoiInfoGClickCb),
        onCouponBtnClick: debounceByPromise(
            useAutoLogin(onCouponBtnClickHandler),
            500,
            true,
        ),
        onOtherDetailClick: (lxID) => {
            const componentID = lxID;
            const url = `${poiInfo.clickMonitorUrl}&componentId=${componentID}`;
            try {
                http.actGeClkM(url);
            } catch (error) {
                console.error('点击上报出错', error);
            }
            return false;
        },
        renderCoupon: totalAmount > 0 ? 'multipleCoupon' : 'oneCoupon',
    });
    return `<div class="mb16">${info}</div>`;
};

/**
 * 渲染商家的模板
 * @param {*} poiInfo
 * @param {*} itemIndex
 * @returns
 */
export const renderPoiInfoH = (poiInfo, itemIndex, recallBizId) => {
    let poiInfoObj = null;
    const onPoiInfoHClickCb = async (currentPoiInfo) => {
        deepLink.gotoDp(currentPoiInfo.dpUrl, currentPoiInfo.lpUrl, () => {
            const componentID = poiInfoObj.describe.getComponentID();
            clickToReport(currentPoiInfo, componentID);
        });
    };
    const onCouponBtnClickHandler = async (currentPoiInfo) => {
        const { giftInfo } = currentPoiInfo;
        const componentID = poiInfoObj.describe.getComponentID();
        // 点击上报
        await clickToReport(currentPoiInfo, componentID);
        if (
            giftInfo.status === COUPON_STATUS.STATUS_NEW &&
            giftInfo.remainStatus === COUPON_REMAIN_STATUS.REMAIN_STATUS_NEW
        ) {
            // 如果是未领取过的券，领取券
            await fetchOneCoupon(currentPoiInfo, recallBizId, true);
        } else if (
            giftInfo.status === COUPON_STATUS.STATUS_RECEIVED &&
            giftInfo.remainStatus ===
                COUPON_REMAIN_STATUS.REMAIN_STATUS_RECEIVED
        ) {
            // 如果是领取过的券，跳转
            deepLink.gotoDp(currentPoiInfo.dpUrl, currentPoiInfo.lpUrl);
        } else if (
            giftInfo.remainStatus === COUPON_REMAIN_STATUS.REMAIN_STATUS_NONE
        ) {
            Toast({
                message: '券已被抢光，请选择其他商家',
                position: 'bottom',
            });
        }
    };
    poiInfoObj = new PoiInfoH({
        poiInfo,
        itemIndex,
        isShowCoupon: true,
        isLazyLoadImg: false,
        onPoiInfoClick: useAutoLogin(onPoiInfoHClickCb),
        onCouponBtnClick: debounceByPromise(
            useAutoLogin(onCouponBtnClickHandler),
            500,
            true,
        ),
    });
    return `<div class="mb16">${poiInfoObj.getComponent()}</div>`;
};

export const renderPoiInfoInSearch = (poiInfo, itemIndex, recallBizId) => {
    if (poiInfo.validInventory === -1) {
        return renderPoiInfoGWithCoupon(poiInfo, itemIndex, recallBizId);
    } else {
        return renderPoiInfoH(poiInfo, itemIndex, recallBizId);
    }
};

export const renderPoiInfoI = (poiInfo, itemIndex, recallBizId) => {
    let poiInfoObj = null;
    // 商家点击
    const onPoiInfoGClickCb = async (currentPoiInfo) => {
        const { giftInfo } = currentPoiInfo;
        // const componentID = poiInfoObj.describe.getComponentID();
        // 点击上报

        if (giftInfo.status === COUPON_STATUS.STATUS_NEW) {
            // 如果是未领取过的券，领取券
            await fetchOneCoupon(currentPoiInfo, recallBizId, false);
        } else if (giftInfo.status === COUPON_STATUS.STATUS_RECEIVED) {
            // 如果是领取过的券，跳转
            deepLink.gotoDp(currentPoiInfo.dpUrl, currentPoiInfo.lpUrl, () => {
                clickToReport(currentPoiInfo);
            });
        }
    };
    const onCouponBtnClickHandler = async (currentPoiInfo) => {
        const { giftInfo } = currentPoiInfo;
        // const componentID = poiInfoObj.describe.getComponentID();
        // 点击上报
        if (giftInfo.status === COUPON_STATUS.STATUS_NEW) {
            // 如果是未领取过的券，领取券
            await fetchOneCoupon(currentPoiInfo, recallBizId, false);
        } else if (giftInfo.status === COUPON_STATUS.STATUS_RECEIVED) {
            // 如果是领取过的券，跳转
            deepLink.gotoDp(currentPoiInfo.dpUrl, currentPoiInfo.lpUrl, () => {
                clickToReport(currentPoiInfo);
            });
        }
    };
    const onSkuClickHandler = async (skuInfo) => {
        try {
            const { giftInfo } = poiInfo;
            if (giftInfo.status === COUPON_STATUS.STATUS_NEW) {
                await fetchOneCoupon(poiInfo, recallBizId, false);
            }
        } catch (error) {
            console.error(error);
        }
        if (skuInfo) {
            deepLink.gotoDp(skuInfo.skuDpUrl, skuInfo.skuLpUrl, () => {
                // 上报
                clickToReport(skuInfo);
            });
        }
    };
    poiInfoObj = new PoiInfoI({
        poiInfo,
        itemIndex,
        onCouponBtnClick: debounceByPromise(
            useAutoLogin(onCouponBtnClickHandler),
            500,
            true,
        ),
        onPoiInfoClick: useAutoLogin(onPoiInfoGClickCb),
        onSkuClick: useAutoLogin(onSkuClickHandler),
    });
    // return `<div class="mb16">${poiInfoObj.getComponent()}</div>`;
    return poiInfoObj;
};
